


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyC-OcamThd8X_YgPWYPUe1KE4o6b6xZQWo",
  authDomain: "inventory-ekanayake-opticals.firebaseapp.com",
  projectId: "inventory-ekanayake-opticals",
  storageBucket: "inventory-ekanayake-opticals.firebasestorage.app",
  messagingSenderId: "76415588752",
  appId: "1:76415588752:web:10d56d00ba5a3e09dcbb15"
};



const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export